import { combineReducers } from "@reduxjs/toolkit"

import assignmentSlice from "./assignment"
import contentHighlightSlice from "./contentHighlightSlice"
import courseAuditSlice from "./courseAuditSlice"
import flashcardSlice from "./flashcardSlice"
import formativeAssessmentSlice from "./formativeAssessmentSlice"
import gameSlice from "./gameSlice"
import GoalSettingAuditSlice from "./goalSettingAuditSlice"
import InterviewAuditSlice from "./interviewAuditSlice"
import questionBankSlice from "./questionBankSlice"
import subjectiveAssessmentSlice from "./subjectiveAssessmentSlice"
import summaryNoteSlice from "./summaryNotesSlice"
import videoSegmentSlice from "./videoSegmentSlice"
import videoSummarizerSlice from "./videoSummarizerSlice"

const swayamReducer = combineReducers({
  game: gameSlice,
  flashcard: flashcardSlice,
  summaryNote: summaryNoteSlice,
  questionBank: questionBankSlice,
  videoSegment: videoSegmentSlice,
  formativeAssessment: formativeAssessmentSlice,
  subjectiveAssessment: subjectiveAssessmentSlice,
  interviewAudit: InterviewAuditSlice,
  assignment: assignmentSlice,
  courseAudit: courseAuditSlice,
  contentHighlight: contentHighlightSlice,
  goalSettingAudit: GoalSettingAuditSlice,
  videoSummarizer: videoSummarizerSlice,
})

export default swayamReducer
